import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "./DownloadButton.module.scss";
import DownloadButton from "../../imgs/download.svg";

const StyledButton = styled(Button)({
  minWidth: 0,
});

const DownloadButtonV2 = (props) => {
  return (
    <StyledButton onClick={props.download}>
      <div className={styles.downloadV2}>
        <img
          alt="Download"
          className={styles.downloadV2Img}
          src={DownloadButton}
        />
        <span className={styles.downloadV2Text}>{props.text}</span>
      </div>
    </StyledButton>
  );
};

export default DownloadButtonV2;
